/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Overview_Getting_Started_DescriptionInputs */

const en_settings_overview_getting_started_description = /** @type {(inputs: Settings_Overview_Getting_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build your product on top of this engine`)
};

const zh_settings_overview_getting_started_description = /** @type {(inputs: Settings_Overview_Getting_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在这个引擎之上构建你的产品`)
};

/**
* | output |
* | --- |
* | "Build your product on top of this engine" |
*
* @param {Settings_Overview_Getting_Started_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_overview_getting_started_description = /** @type {((inputs?: Settings_Overview_Getting_Started_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Overview_Getting_Started_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_overview_getting_started_description(inputs)
	return zh_settings_overview_getting_started_description(inputs)
});
export { settings_overview_getting_started_description as "settings.overview.getting_started_description" }